import React from "react";
import { GlobalContext } from "../context/GlobalContext";
import { login, twofactor } from "../api";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useNotifications } from "../helpers/useNotifications";

function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { refreshUser } = useAuth();
  const createNotification = useNotifications();
  const { isMobile } = React.useContext(GlobalContext);

  const [status, setStatus] = React.useState("login");
  const [currentUser, setCurrentUser] = React.useState();

  const origin = location.state?.from?.pathname || "/blog";

  //* handle login submit
  const handleLogin = async (e) => {
    e.preventDefault();

    const username = e.target[0]?.value;
    const password = e.target[1]?.value;

    setCurrentUser(username);

    try {
      const data = await login(username, password);
      createNotification("success", data.message);
      setStatus("twofactor");
      // await refreshUser();
      // navigate(origin, { replace: true });
    } catch (error) {
      createNotification("error", error.message);
    }

    const formular = document.getElementById("loginForm");
    formular?.reset();
  };

  //* handle login submit
  const handleTwofactor = async (e) => {
    e.preventDefault();

    const code =
      e.target[0]?.value +
      e.target[1]?.value +
      e.target[2]?.value +
      e.target[3]?.value +
      e.target[4]?.value +
      e.target[5]?.value;

    if (code.length !== 6) {
      createNotification("error", "Bitte vollständigen Code eingeben.");
    } else {
      try {
        await twofactor(currentUser, code);
        await refreshUser();
        navigate(origin, { replace: true });
        setStatus("login");
      } catch (error) {
        createNotification("error", error.message);
      }

      const formular = document.getElementById("twofaForm");
      formular?.reset();
    }
  };

  const inputs = document.querySelectorAll("#twofaForm input");

  inputs.forEach((input, index) => {
    input.addEventListener("input", (e) => {
      const value = e.target.value;

      // Nur Ziffern erlauben
      e.target.value = value.replace(/\D/, "");

      if (value && index < inputs.length - 1) {
        inputs[index + 1].focus();
      }
    });

    input.addEventListener("keydown", (e) => {
      if (e.key === "Backspace" && !e.target.value && index > 0) {
        inputs[index - 1].focus();
      }
    });
  });

  if (status === "twofactor") {
    return (
      <div
        className={`card border-primary ${
          isMobile ? "col-12" : "col-lg-6"
        } justify-content-center bg-dark  ${!isMobile && "article-text"} ${
          isMobile && "add-padding-20"
        } text-justify text-light`}
      >
        <h1 className="text-light article-header">Verifizierungscode</h1>
        <br />

        <form onSubmit={handleTwofactor} id="twofaForm" className="ml-4">
          <div className="d-flex gap-5 justify-content-center twofactor-form">
            <input
              type="text"
              className="form-control text-center"
              maxlength="1"
              inputmode="numeric"
              pattern="[0-9]*"
              id="digit-1"
              autocomplete="one-time-code"
              autofocus
            />
            <input
              type="text"
              className="form-control text-center"
              maxlength="1"
              inputmode="numeric"
              pattern="[0-9]*"
              id="digit-2"
            />
            <input
              type="text"
              className="form-control text-center"
              maxlength="1"
              inputmode="numeric"
              pattern="[0-9]*"
              id="digit-3"
            />
            <input
              type="text"
              className="form-control text-center"
              maxlength="1"
              inputmode="numeric"
              pattern="[0-9]*"
              id="digit-4"
            />
            <input
              type="text"
              className="form-control text-center"
              maxlength="1"
              inputmode="numeric"
              pattern="[0-9]*"
              id="digit-5"
            />
            <input
              type="text"
              className="form-control text-center"
              maxlength="1"
              inputmode="numeric"
              pattern="[0-9]*"
              id="digit-6"
            />
          </div>
          <br />
          <div className="text-right">
            <button type="submit" className="btn btn-primary formsubmit">
              Code bestätigen
            </button>
          </div>
        </form>
      </div>
    );
  }
  return (
    <div
      className={`card border-primary ${
        isMobile ? "col-12" : "col-lg-6"
      } justify-content-center bg-dark  ${!isMobile && "article-text"} ${
        isMobile && "add-padding-20"
      } text-justify text-light`}
    >
      <h1 className="text-light article-header">Login</h1>
      <br />
      <form onSubmit={handleLogin} id="loginForm">
        <div className="form-group">
          <label className="text-light" for="formUser">
            Username
          </label>
          <input type="text" className="form-control" id="formUser" required />
        </div>

        <div className="form-group">
          <label className="text-light" for="formPassword">
            Passwort
          </label>
          <input
            type="password"
            className="form-control"
            id="formPassword"
            required
          />
        </div>

        <div className="text-right">
          <button type="submit" className="btn btn-primary formsubmit">
            Anmelden
          </button>
        </div>
      </form>
    </div>
  );
}

export default Login;
